import { render, staticRenderFns } from "./AboutProject.vue?vue&type=template&id=7b6fde82&"
import script from "./AboutProject.vue?vue&type=script&lang=js&"
export * from "./AboutProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports